// Menu complet Le Paradis – Bondy avec compositions

export const menuData = {
  pizzasSauceTomate: {
    id: 'pizzas-tomate',
    title: 'Pizzas — Base Sauce Tomate',
    icon: 'Pizza',
    priceTiers: [
      {
        prices: { senior: 6.99, mega: 11.99 },
        items: [
          { name: 'Margherita', composition: 'Sauce tomate, mozzarella.' },
          { name: 'Bolo', composition: 'Sauce tomate, mozzarella, viande hachée, oignons.' },
          { name: 'Orientale', composition: 'Sauce tomate, mozzarella, merguez, poivrons, olives, oignons, œuf.' },
          { name: 'Nan Tomate', composition: 'Sauce tomate, mozzarella, merguez, viande hachée.' },
          { name: 'Reine', composition: 'Sauce tomate, mozzarella, jambon de dinde, champignons.' },
          { name: 'Paradis', composition: 'Sauce tomate, mozzarella, chorizo, poulet tandoori, poivrons.' },
          { name: 'Kebab', composition: 'Sauce tomate, mozzarella, kebab, poivrons, oignons.' },
          { name: 'Kefta', composition: 'Sauce tomate, mozzarella, viande hachée, champignons, poivrons, oignons, œuf.' },
          { name: '4 Fromages', composition: 'Sauce tomate, mozzarella, viande hachée, bleu, chèvre, cheddar.' },
          { name: 'Barbecue', composition: 'Sauce tomate, mozzarella, chorizo, viande hachée, oignons, sauce barbecue.' },
          { name: 'Burger', composition: 'Sauce tomate, sauce burger, mozzarella, viande hachée, cheddar, oignons.' },
          { name: 'Fruits de mer', composition: 'Sauce tomate, mozzarella, cocktail de fruits de mer.' },
          { name: 'Neptune', composition: 'Sauce tomate, mozzarella, thon, olives, œuf.' },
          { name: 'Napolitaine', composition: 'Sauce tomate, mozzarella, câpres, anchois, olives.' },
          { name: 'Hot Fajitas', composition: 'Sauce tomate, sauce chilli thaï, chorizo, poivrons, oignons.' },
          { name: 'Végétarienne', composition: 'Sauce tomate, mozzarella, champignons, poivrons, oignons, pomme de terre.' }
        ]
      },
      {
        prices: { senior: 7.99, mega: 14.99 },
        items: [
          { name: 'Cannibale', composition: 'Sauce tomate, mozzarella, viande hachée, merguez, kebab.' },
          { name: '3 Jambon', composition: 'Sauce tomate, mozzarella, jambon, lardon, chorizo.' },
          { name: 'Mexicaine', composition: 'Sauce tomate, mozzarella, viande hachée, merguez, bacon de bœuf, jalapeños.' }
        ]
      },
      {
        prices: { senior: 8.99, mega: 15.99 },
        items: [
          { name: 'Royal', composition: 'Sauce tomate, mozzarella, viande hachée, poulet curry, kebab, bacon de bœuf, poivrons, oignons.' }
        ]
      }
    ],
    supplements: [
      { label: 'Senior', viande: 1.50, legumes: 0.50 },
      { label: 'Mega', viande: 2.50, legumes: 1.00 }
    ]
  },

  pizzasCremeFraiche: {
    id: 'pizzas-creme',
    title: 'Pizzas — Base Crème Fraîche',
    icon: 'Pizza',
    priceTiers: [
      {
        prices: { senior: 6.99, mega: 11.99 },
        items: [
          { name: 'La Chicken', composition: 'Crème fraîche, mozzarella, poulet curry, pomme de terre, olives.' },
          { name: 'Tartiflette', composition: 'Crème fraîche, mozzarella, lardons de dinde, pomme de terre, oignons.' },
          { name: 'Savoyarde', composition: 'Crème fraîche, mozzarella, jambon de dinde, pomme de terre, oignons.' },
          { name: 'Américaine', composition: 'Crème fraîche, mozzarella, ketchup, viande hachée, pommes de terre, oignons.' },
          { name: 'Chèvre Miel', composition: 'Crème fraîche, mozzarella, chèvre, miel.' },
          { name: 'Nan Crème', composition: 'Crème fraîche, mozzarella, merguez, viande hachée.' },
          { name: 'Anglaise', composition: 'Crème fraîche, mozzarella, jambon, viande hachée, cheddar, œuf.' },
          { name: 'Montagnard', composition: 'Crème fraîche, mozzarella, viande hachée, bleu, chèvre, œuf.' },
          { name: 'Carbonara', composition: 'Crème fraîche, mozzarella, champignons, lardons de dinde, œuf.' },
          { name: 'Saumon', composition: 'Crème fraîche, mozzarella, saumon fumé.' },
          { name: 'Reblochon', composition: 'Crème fraîche, mozzarella, lardons de dinde, reblochon, pommes de terre.' },
          { name: 'Raclette Jambon', composition: 'Crème fraîche, mozzarella, raclette, jambon.' },
          { name: 'Boursin Poulet', composition: 'Crème fraîche, mozzarella, poulet curry, boursin.' },
          { name: 'Bollywood', composition: 'Crème fraîche, sauce curry, mozzarella, poulet curry, poivrons, oignons.' },
          { name: 'Algérienne', composition: 'Crème fraîche, sauce algérienne, mozzarella, poulet curry, merguez, poivron, oignon.' }
        ]
      },
      {
        prices: { senior: 7.99, mega: 14.99 },
        items: [
          { name: 'Indienne', composition: 'Crème fraîche, mozzarella, poulet curry, poulet tandoori, champignons, pomme de terre.' },
          { name: 'Chef', composition: 'Crème fraîche, mozzarella, kebab, poulet tandoori, œuf.' }
        ]
      }
    ],
    supplements: [
      { label: 'Senior', viande: 1.50, legumes: 0.50 },
      { label: 'Mega', viande: 2.50, legumes: 1.00 }
    ]
  },

  offreEmporter: {
    id: 'offre-emporter',
    title: 'Offre à Emporter',
    icon: 'ShoppingBag',
    offers: [
      {
        name: '3 Pizzas Senior',
        price: 19.99,
        note: 'À emporter uniquement'
      }
    ]
  },

  calzones: {
    id: 'calzones',
    title: 'Calzones',
    icon: 'Sandwich',
    price: 6.99,
    categories: [
      {
        base: 'Sauce Tomate',
        items: [
          { name: 'Calzone Bolognaise', composition: 'Mozzarella, viande hachée, œuf.' },
          { name: 'Calzone Jambon', composition: 'Mozzarella, jambon, œuf.' }
        ]
      },
      {
        base: 'Crème Fraîche',
        items: [
          { name: 'Calzone Reblochon', composition: 'Mozzarella, lardons de dinde, reblochon, pommes de terre.' },
          { name: 'Calzone Poulet', composition: 'Champignons, poulet curry, œuf.' }
        ]
      }
    ]
  },

  naanwich: {
    id: 'naanwich',
    title: 'Naanwich',
    icon: 'Utensils',
    description: 'Salade, tomates, oignons, cheddar',
    prices: { seul: 7.90, menu: 9.90 },
    items: [
      { name: 'Poulet curry', composition: 'Naan garni de poulet curry, salade, tomates, oignons, cheddar.' },
      { name: 'Poulet tandoori', composition: 'Naan garni de poulet tandoori, salade, tomates, oignons, cheddar.' },
      { name: 'Poulet tikka', composition: 'Naan garni de poulet tikka, salade, tomates, oignons, cheddar.' },
      { name: 'Poulet boursin', composition: 'Naan garni de poulet boursin, salade, tomates, oignons, cheddar.' },
      { name: 'Poulet kebab', composition: 'Naan garni de poulet kebab, salade, tomates, oignons, cheddar.' },
      { name: 'Tenders', composition: 'Naan garni de tenders de poulet, salade, tomates, oignons, cheddar.' },
      { name: 'Cordon bleu', composition: 'Naan garni de cordon bleu, salade, tomates, oignons, cheddar.' },
      { name: 'Steak', composition: 'Naan garni de steak haché, salade, tomates, oignons, cheddar.' }
    ],
    supplement: { label: 'Supplément viande', price: 2.00 }
  },

  snacks: {
    id: 'snacks',
    title: 'Snacks',
    icon: 'UtensilsCrossed',
    categories: [
      {
        name: 'Burgers',
        description: 'Salade, tomates, oignons, cheddar',
        prices: { seul: 6.99, menu: 8.99 },
        supplement: { label: 'Supplément steak', price: 1.50 },
        composition: 'Pain burger, steak haché, salade, tomates, oignons, cheddar, sauce.'
      },
      {
        name: 'Tacos',
        description: 'Frites, viande, sauce fromage',
        prices: { seul: 6.99, menu: 7.99 },
        supplements: [
          { label: 'Viande', price: 1.00 },
          { label: 'Légumes', price: 0.50 }
        ],
        composition: 'Tortilla, frites, viande au choix, sauce fromage.'
      },
      {
        name: 'Sandwiches',
        description: 'Salade, tomates, oignons, cheddar',
        prices: { seul: 6.99, menu: 8.99 },
        items: [
          { name: 'Poulet curry', composition: 'Pain, poulet curry, salade, tomates, oignons, cheddar.' },
          { name: 'Poulet tikka', composition: 'Pain, poulet tikka, salade, tomates, oignons, cheddar.' },
          { name: 'Poulet tandoori', composition: 'Pain, poulet tandoori, salade, tomates, oignons, cheddar.' },
          { name: 'Poulet pané', composition: 'Pain, poulet pané, salade, tomates, oignons, cheddar.' },
          { name: 'Steak', composition: 'Pain, steak haché, salade, tomates, oignons, cheddar.' }
        ]
      }
    ]
  },

  crepes: {
    id: 'crepes',
    title: 'Crêpes Sucrées',
    icon: 'Cookie',
    items: [
      { name: 'Nutella', price: 3.00, composition: 'Crêpe maison garnie de Nutella.' },
      { name: 'Chocolat', price: 3.00, composition: 'Crêpe maison garnie de chocolat.' },
      { name: 'Nutella banane', price: 4.00, composition: 'Crêpe maison garnie de Nutella et banane fraîche.' },
      { name: 'Nutella Kinder Bueno', price: 4.50, composition: 'Crêpe maison garnie de Nutella et morceaux de Kinder Bueno.' },
      { name: 'Nutella KitKat', price: 4.50, composition: 'Crêpe maison garnie de Nutella et morceaux de KitKat.' },
      { name: 'Nutella Oreo', price: 4.50, composition: 'Crêpe maison garnie de Nutella et morceaux d\'Oreo.' }
    ]
  }
};

export const menuCategories = [
  'pizzasSauceTomate',
  'pizzasCremeFraiche',
  'offreEmporter',
  'calzones',
  'naanwich',
  'snacks',
  'crepes'
];
